import * as yup from "yup";
import objectsSchema from "schemas/objectsSchema";
import { checkIfEmptyObject, getTipCetatenie } from "helpers/helpers";
import { requestJson, RequestMethod } from "helpers/httpHelper";

const cnpRegex = /^[1-2,5-8]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d|5[0-2]|99)(00[1-9]|0[1-9]\d|[1-9]\d\d)\d$/;
const clcPodRegexCaractere = /^[A-Za-z0-9-\b]+$/;
const clcPodRegex = new RegExp(`^(${objectsSchema.operatoriCLC.join("|")})`);
const telefonRegex = /^\d{8,}$/;
const dateRegex = /^(0[1-9]|[12][0-9]|3[01])([./])(0[1-9]|1[0-2])\2\d{2}$/;
const numarCIRegex = /^\d{6}$/;
const serieCIRegex = /^[A-Za-z]{2}$/;
const nifRegex = /^\d{5,}$/;
const telefonStrainRegex = /^(?=.*\d{6,}).*[+]*.*$/;

const supportedFormatsBase64 = ["pdf", "png", "jpg", "jpeg"];
const supportedFormatsFile = ["application/pdf", "image/png", "image/jpg", "image/jpeg"];

export const yupSchemaStep1 = yup.object().shape({
   judet: yup.string().required("Selectați județul"),
   localitate: yup.string().required("Selectați localitatea"),
});

export const yupSchemaStep3 = yup.object().shape({
   prenume: yup.string().required("Prenumele este obligatoriu"),
   nume: yup.string().required("Numele este obligatoriu"),
   email: yup.string().email("Email invalid").required("Email-ul este obligatoriu"),
   emailConfirm: yup
      .string()
      .oneOf([yup.ref("email"), null], "Email-urile nu se potrivesc")
      .required("Confirmarea emailului este obligatorie"),
   telefon: yup.string().when("tipCetatenie", {
      is: "ROMAN",
      then: yup.string().min(8, "Numărul de telefon nu este corect").required("Telefonul este obligatoriu"),
      otherwise: yup.string().required("Telefonul este obligatoriu").min(6, "NIF-ul este format din minim 6 cifre"),
   }),
   cnp: yup.string().when("tipCetatenie", {
      is: "ROMAN",
      then: yup.string().matches(cnpRegex, "CNP-ul introdus are formatul gresit").required("CNP-ul este obligatoriu"),
      otherwise: yup.string().nullable(),
   }),
   nif: yup.string().when("tipCetatenie", {
      is: "STRAIN",
      then: yup.string().required("NIF-ul este obligatoriu").min(5, "NIF-ul este format din minim 5 cifre"),
      otherwise: yup.string().nullable(),
   }),
   tara: yup.string().when("tipCetatenie", {
      is: "STRAIN",
      then: yup.string().required("Țara este obligatorie"),
      otherwise: yup.string().nullable(),
   }),

   semnatura: yup.string().required("Semnătura este obligatorie și trebuie confirmată"),
   newsletter: yup.boolean(),
   analytics: yup.boolean(),
});

export const yupSchemaStep4 = yup.object().shape({
   beneficieziInPrezent: yup.boolean().required("Acest camp este obligatoriu"),
   schimbiTitular: yup.mixed().test("schimbiTitular", "Acest camp este obligatoriu", (value, parent) => {
      const beneficieziInPrezent = parent.parent.beneficieziInPrezent;
      if (beneficieziInPrezent === false) return true;
      if (value === '' || value === undefined) throw new yup.ValidationError("Acest camp este obligatoriu", parent.parent, parent.path);

      return true;
   }),
   premierEnergyTitular: yup.mixed().test("premierEnergyTitular", "Acest camp este obligatoriu", (value, parent) => {
      const beneficieziInPrezent = parent.parent.beneficieziInPrezent;
      if (beneficieziInPrezent === false) return true;
      if (value === '' || value === undefined) throw new yup.ValidationError("Acest camp este obligatoriu", parent.parent, parent.path);

      return true;
   }),
   furnizorActual: yup.mixed().test("furnizorActual", "Acest camp este obligatoriu", (value, parent) => {
      const premierEnergyTitular = parent.parent.premierEnergyTitular;
      if (premierEnergyTitular === true) return true;
      if (value === '' || value === undefined) throw new yup.ValidationError("Acest camp este obligatoriu", parent.parent, parent.path);

      return true;
   }),

   fileFacturaPIF: yup.mixed().test("fileFacturaPIF", "Acest camp este obligatoriu", (value, parent) => {
      const isPIF = parent.parent.isPIF;

      if (isPIF === false) { return true; }
      // if(parent.parent.beneficieziInPrezent === true) return true;

      if (value === '' || value === undefined || value === null) throw new yup.ValidationError("Acest camp este obligatoriu", parent.parent, parent.path);

      return true;
   }),
   fileDovadaPlata: yup.mixed().test("fileDovadaPlata", "Acest camp este obligatoriu", (value, parent) => {
      const isPIF = parent.parent.isPIF;

      // if(parent.parent.beneficieziInPrezent === true) return true;
      if (isPIF === false) { return true; }
      else {
         if (value === '' || value === undefined || value === null) throw new yup.ValidationError("Acest camp este obligatoriu", parent.parent, parent.path);

      }

      return true;
   }),
});

export const yupSchemaStep5 = yup.object().shape({
   fileCI: yup.mixed().test("fileFormat", "Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "STRAIN") return true;

      //daca nu exista fisierul -> eroare
      if (!value) throw new yup.ValidationError("Fișierul este obligatoriu", parent.parent, parent.path);

      //daca este obiect gol si acesta nu este fisier -> eroare
      if (checkIfEmptyObject(value)) throw new yup.ValidationError("Fișierul trebuie reîncărcat", parent.parent, parent.path);

      //BASE64 FORMAT
      if (typeof value === "string") {
         const fileFormat = value.split(";")[0].split("/")[1];
         const isValidFormat = supportedFormatsBase64.includes(fileFormat);
         //daca fisierul nu are unul din formatele acceptate -> eroare
         if (!isValidFormat)
            throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

         return true;
      }

      //FILE FORMAT
      const fileFormat = value?.type;
      const isValidFormat = supportedFormatsFile.includes(fileFormat);
      //daca fisierul nu are unul din formatele acceptate -> eroare
      if (!isValidFormat)
         throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

      //daca fisierul are mai mult de x MB -> eroare
      if (value.size > 5000000) throw new yup.ValidationError("Fișierul nu poate avea mai mult de 5MB", parent.parent, parent.path);

      return true;
   }),
   fileNIF: yup.mixed().test("fileFormat", "Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      //daca nu exista fisierul -> eroare
      if (!value) throw new yup.ValidationError("Fișierul NIF este obligatoriu", parent.parent, parent.path);

      //daca este obiect gol si acesta nu este fisier -> eroare
      if (checkIfEmptyObject(value)) throw new yup.ValidationError("Fișierul NIF trebuie reîncărcat", parent.parent, parent.path);

      //BASE64 FORMAT
      if (typeof value === "string") {
         const fileFormat = value.split(";")[0].split("/")[1];
         const isValidFormat = supportedFormatsBase64.includes(fileFormat);
         //daca fisierul nu are unul din formatele acceptate -> eroare
         if (!isValidFormat)
            throw new yup.ValidationError("Fișierul NIF nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

         return true;
      }

      //FILE FORMAT
      const fileFormat = value?.type;
      const isValidFormat = supportedFormatsFile.includes(fileFormat);
      //daca fisierul nu are unul din formatele acceptate -> eroare
      if (!isValidFormat)
         throw new yup.ValidationError("Fișierul NIF nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

      //daca fisierul are mai mult de x MB -> eroare
      if (value.size > 5000000) throw new yup.ValidationError("Fișierul NIF nu poate avea mai mult de 5MB", parent.parent, parent.path);

      return true;
   }),
   filePasaport: yup.mixed().test("fileFormat", "Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      //daca nu exista fisierul -> eroare
      if (!value) throw new yup.ValidationError("Fișierul pașaport este obligatoriu", parent.parent, parent.path);

      //daca este obiect gol si acesta nu este fisier -> eroare
      if (checkIfEmptyObject(value)) throw new yup.ValidationError("Fișierul pașaport trebuie reîncărcat", parent.parent, parent.path);

      //BASE64 FORMAT
      if (typeof value === "string") {
         const fileFormat = value.split(";")[0].split("/")[1];
         const isValidFormat = supportedFormatsBase64.includes(fileFormat);
         //daca fisierul nu are unul din formatele acceptate -> eroare
         if (!isValidFormat)
            throw new yup.ValidationError("Fișierul pașaport nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

         return true;
      }

      //FILE FORMAT
      const fileFormat = value?.type;
      const isValidFormat = supportedFormatsFile.includes(fileFormat);
      //daca fisierul nu are unul din formatele acceptate -> eroare
      if (!isValidFormat)
         throw new yup.ValidationError("Fișierul pașaport nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

      //daca fisierul are mai mult de x MB -> eroare
      if (value.size > 5000000) throw new yup.ValidationError("Fișierul pașaport nu poate avea mai mult de 5MB", parent.parent, parent.path);

      return true;
   }),
   filePermisSedere: yup.mixed().test("fileFormat", "Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      // //daca nu exista fisierul -> eroare
      // if (!value) throw new yup.ValidationError("Fișierul este obligatoriu", parent.parent, parent.path);

      // daca este obiect gol si acesta nu este fisier -> return true
      if (checkIfEmptyObject(value)) return true;

      //BASE64 FORMAT
      if (typeof value === "string" && value !== null) {
         const fileFormat = value.split(";")[0].split("/")[1];
         const isValidFormat = supportedFormatsBase64.includes(fileFormat);
         //daca fisierul nu are unul din formatele acceptate -> eroare
         if (!isValidFormat)
            throw new yup.ValidationError(
               "Fișierul permis de ședere nu este în formatul corespunzător (pdf, png, jpg, jpeg)",
               parent.parent,
               parent.path,
            );

         return true;
      }

      //FILE FORMAT
      const fileFormat = value?.type;
      const isValidFormat = supportedFormatsFile.includes(fileFormat);
      //daca fisierul nu are unul din formatele acceptate -> eroare
      if (!isValidFormat && value !== null)
         throw new yup.ValidationError(
            "Fișierul permis de ședere nu este în formatul corespunzător (pdf, png, jpg, jpeg)",
            parent.parent,
            parent.path,
         );

      //daca fisierul are mai mult de x MB -> eroare
      if (value?.size > 5000000) throw new yup.ValidationError("Fișierul nu poate avea mai mult de 5MB", parent.parent, parent.path);

      return true;
   }),
   fileAlteDocumente: yup.mixed().test("fileFormat", "Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      // //daca nu exista fisierul -> eroare
      // if (!value) throw new yup.ValidationError("Fișierul este obligatoriu", parent.parent, parent.path);

      //daca este obiect gol si acesta nu este fisier -> return true
      if (checkIfEmptyObject(value)) return true;

      //BASE64 FORMAT
      if (typeof value === "string" && value !== null) {
         const fileFormat = value.split(";")[0].split("/")[1];
         const isValidFormat = supportedFormatsBase64.includes(fileFormat);
         //daca fisierul nu are unul din formatele acceptate -> eroare
         if (!isValidFormat)
            throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

         return true;
      }

      //FILE FORMAT
      const fileFormat = value?.type;
      const isValidFormat = supportedFormatsFile.includes(fileFormat);
      //daca fisierul nu are unul din formatele acceptate -> eroare
      if (!isValidFormat && value !== null)
         throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

      //daca fisierul are mai mult de x MB -> eroare
      if (value?.size > 5000000) throw new yup.ValidationError("Fișierul nu poate avea mai mult de 5MB", parent.parent, parent.path);

      return true;
   }),
});

export const yupSchemaStep6 = yup.object().shape({
   nume: yup.string().required("Numele este obligatoriu"),
   prenume: yup.string().required("Prenumele este obligatoriu"),

   serieCI: yup.mixed().test("serieCIR", "Seria CI este obligatorie", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "STRAIN") return true;

      if (!value) throw new yup.ValidationError("Seria CI este obligatorie", parent.parent, parent.path);
      const isSerieCIValid = serieCIRegex.test(value);
      if (!isSerieCIValid) throw new yup.ValidationError("Seria CI este de format greșit", parent.parent, parent.path);

      return true;
   }),
   numarCI: yup.mixed().test("numarCIR", "Numărul CI este obligatoriu", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "STRAIN") return true;

      if (!value) throw new yup.ValidationError("Numărul CI este obligatoriu", parent.parent, parent.path);
      const isNumarCIValid = numarCIRegex.test(value);
      if (!isNumarCIValid) throw new yup.ValidationError("Numărul CI este de format greșit", parent.parent, parent.path);

      return true;
   }),
   emisDeCI: yup.mixed().test("emisDeCIR", "Eliberat de CI este obligatoriu", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "STRAIN") return true;

      if (!value) throw new yup.ValidationError("Eliberat de CI este obligatoriu", parent.parent, parent.path);

      return true;
   }),
   emisLaCI: yup.mixed().test("emisLaCIR", "Data eliberării CI este obligatorie", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "STRAIN") return true;

      if (!value) throw new yup.ValidationError("Data eliberării CI este obligatorie", parent.parent, parent.path);
      const isEmisLaCIValid = dateRegex.test(value);
      if (!isEmisLaCIValid) throw new yup.ValidationError("Data eliberării CI este de format greșit", parent.parent, parent.path);

      return true;
   }),
   expiraLaCI: yup.mixed().test("expiraLaCIR", "Data expirării CI este obligatorie", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "STRAIN") return true;

      if (!value) throw new yup.ValidationError("Data expirării CI este obligatorie", parent.parent, parent.path);
      const isExpiraLaCIValid = dateRegex.test(value);
      if (!isExpiraLaCIValid) throw new yup.ValidationError("Data expirării CI este de format greșit", parent.parent, parent.path);

      return true;
   }),
   cnp: yup.mixed().test("cnpR", "Cnp-ul este oblig", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "STRAIN") return true;

      if (!value) throw new yup.ValidationError("CNP-ul este obligatoriu", parent.parent, parent.path);
      const isCnpValid = cnpRegex.test(value);
      if (!isCnpValid) throw new yup.ValidationError("CNP-ul este de format greșit", parent.parent, parent.path);

      return true;
   }),

   nif: yup.mixed().test("nif", "NIF-ul este obligatoriu", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      if (!value) throw new yup.ValidationError("NIF-ul este obligatoriu", parent.parent, parent.path);
      const isNifValid = nifRegex.test(value);
      if (!isNifValid) throw new yup.ValidationError("NIF-ul este format din minim 5 cifre", parent.parent, parent.path);

      return true;
   }),
   nrPasaport: yup.mixed().test("nrPasaport", "Numărul pașaportului este obligatoriu", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      if (!value) throw new yup.ValidationError("Numărul pașaportului este obligatoriu", parent.parent, parent.path);

      return true;
   }),
   emisLaPasaport: yup.mixed().test("emisLaPasaport", "Data emiterii pașaportului este obligatorie", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      if (!value) throw new yup.ValidationError("Data emiterii pașaportului este obligatorie", parent.parent, parent.path);
      const isEmisLaPasaportValid = dateRegex.test(value);
      if (!isEmisLaPasaportValid) throw new yup.ValidationError("Data emiterii pașaportului este de format greșit", parent.parent, parent.path);

      return true;
   }),
   expiraLaPasaport: yup.mixed().test("expiraLaPasaport", "Data expirării pașaportului este obligatorie", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      if (!value) throw new yup.ValidationError("Data expirării pașaportului este obligatorie", parent.parent, parent.path);
      const isExpiraPasaportLaValid = dateRegex.test(value);
      if (!isExpiraPasaportLaValid) throw new yup.ValidationError("Data expirării pașaportului este de format greșit", parent.parent, parent.path);

      return true;
   }),
   taraEmitenta: yup.mixed().test("taraEmitenta", "Țara emitentă este obligatorie", (value, parent) => {
      const tipCetatenie = getTipCetatenie();
      if (tipCetatenie === "ROMAN") return true;

      if (!value) throw new yup.ValidationError("Țara emitentă este obligatorie", parent.parent, parent.path);

      return true;
   }),

   domiciliu: yup.object().when("adresaConsumDomiciliu", {
      is: false,
      then: yup.object().shape({
         judet: yup.string().required("Selectați județul"),
         localitate: yup.string().required("Selectați localitatea"),
         tipStrada: yup.string().required("Tipul străzii este obligatoriu"),
         strada: yup.string().required("Numele străzii este obligatoriu"),
         numar: yup.string(),
         bloc: yup.string(),
         scara: yup.string(),
         etaj: yup.string().max(3, "Maxim 3 cifre"),
         apartament: yup.string(),
         codPostal: yup.string().min(5, "Codul poștal este format minim din 5 cifre").max(6, "Maxim 6 cifre"),
      }),
   }),
   adresaConsumDomiciliu: yup.boolean(),
   consum: yup.object().shape({
      judet: yup.string().required("Selectați județul"),
      localitate: yup.string().required("Selectați localitatea"),
      tipStrada: yup.string().required("Tipul străzii este obligatoriu"),
      strada: yup.string().required("Numele străzii este obligatoriu"),
      numar: yup.string(),
      bloc: yup.string(),
      scara: yup.string(),
      etaj: yup.string().max(3, "Maxim 3 cifre"),
      apartament: yup.string(),
      codPostal: yup.string().min(5, "Codul poștal este format minim din 5 cifre").max(6, "Maxim 6 cifre"),
   }),
   telefon: yup.mixed().test("phoneNumber", "Telefonul este obligatoriu", (value, parent) => {
      const tipCetatenie = getTipCetatenie();

      if (tipCetatenie === "ROMAN") {
         const isValid = telefonRegex.test(value);
         if (!isValid) throw new yup.ValidationError("Numărul de telefon nu este corect", parent.parent, parent.path);
      }

      if (tipCetatenie === "STRAIN") {
         if (!value) throw new yup.ValidationError("Numărul de telefon este obligatoriu", parent.parent, parent.path);

         const isTelefonValidStrain = telefonStrainRegex.test(value);
         if (!isTelefonValidStrain) throw new yup.ValidationError("Numărul de telefon are minim 6 caractere", parent.parent, parent.path);
      }

      return true;
   }),

   email: yup.string().email("Email invalid").required("Email-ul este obligatoriu"),
   facturaMail: yup.boolean(),
   corespondenta: yup.object().when("facturaMail", {
      is: false,
      then: yup.object().shape({
         judet: yup.string().required("Selectați județul"),
         localitate: yup.string().required("Selectați localitatea"),
         tipStrada: yup.string().required("Tipul străzii este obligatoriu"),
         strada: yup.string().required("Numele străzii este obligatoriu"),
         numar: yup.string(),
         bloc: yup.string(),
         scara: yup.string(),
         etaj: yup.string().max(3, "Maxim 3 cifre"),
         apartament: yup.string(),
         codPostal: yup
            .string()
            .min(5, "Codul poștal este format minim din 5 cifre")
            .max(6, "Maxim 6 cifre")
            .required("Codul poștal este obligatoriu"),
      }),
   }),
});
export const yupSchemaStep7 = yup.object().shape({
   fileCLCPOD: yup.mixed().test("fileFormat", "Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", (value, parent) => {
      const isPIF = parent.parent.isPIF;

      if (isPIF === true) {
         if (!value) {
            throw new yup.ValidationError("Fișierul este obligatoriu", parent.parent, parent.path);
         }
      }else{ return true; }

      //daca nu exista fisierul -> return true
      if (!value) return true;
      //daca este obiect gol si acesta nu este fisier -> return true
      if (checkIfEmptyObject(value)) return true;

      ////daca este obiect gol si acesta nu este fisier -> eroare
      //  if (checkIfEmptyObject(value))
      //    throw new yup.ValidationError("Fișierul trebuie reîncărcat", parent.parent, parent.path);

      //BASE64 FORMAT
      if (typeof value === "string") {
         const fileFormat = value.split(";")[0].split("/")[1];
         const isValidFormat = supportedFormatsBase64.includes(fileFormat);
         //daca fisierul nu are unul din formatele acceptate -> eroare
         if (!isValidFormat)
            throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

         return true;
      }

      //FILE FORMAT
      const fileFormat = value?.type;
      const isValidFormat = supportedFormatsFile.includes(fileFormat);
      //daca fisierul nu are unul din formatele acceptate -> eroare
      if (!isValidFormat)
         throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

      //daca fisierul are mai mult de x MB -> eroare
      if (value.size > 5000000) throw new yup.ValidationError("Fișierul nu poate avea mai mult de 5MB", parent.parent, parent.path);

      return true;
   }),
});

export const yupSchemaStep8 = yup.object().shape(
   {
      calitateDetinator: yup.string().required("Selectați calitatea deținatorului"),
      valabilitateChirie: yup.date().when("calitateDetinator", {
         is: value => value === "chirias" || value === "comodator",
         then: yup.date().nullable().required("Data expirării contractului este obligatorie"),
         otherwise: yup.date(),
      }),
      fileCoProprietar: yup.array(),
      scopConsum: yup.boolean(),
      unitateMasura: yup.string(),
      categorieConsum: yup.string(),
      indexLuni: yup.object().shape({
         ianuarie: yup.string().required("Camp obligatoriu"),
         februarie: yup.string().required("Camp obligatoriu"),
         martie: yup.string().required("Camp obligatoriu"),
         aprilie: yup.string().required("Camp obligatoriu"),
         mai: yup.string().required("Camp obligatoriu"),
         iunie: yup.string().required("Camp obligatoriu"),
         iulie: yup.string().required("Camp obligatoriu"),
         august: yup.string().required("Camp obligatoriu"),
         septembrie: yup.string().required("Camp obligatoriu"),
         octombrie: yup.string().required("Camp obligatoriu"),
         noiembrie: yup.string().required("Camp obligatoriu"),
         decembrie: yup.string().required("Camp obligatoriu"),
      }),
      acordConventieConsum: yup.bool().oneOf([true], "Acordul este obligatoriu"),
      sumOfIndexLuni: yup.mixed().test("sumOfIndexLuni", "Suma indexurilor este incorectă", function (value, parent) {
         const sumOfIndexLuni = Object.values(parent.parent.indexLuni).reduce((acc, curr) => acc + Number(curr), 0);
         const categorieConsum = parent.parent.categorieConsum;

         // console.log(parent.parent);
         if (categorieConsum === "C1" && sumOfIndexLuni > 26034)
            throw new yup.ValidationError(
               "Consumul introdus depaseste pragul maxim acceptat pe categoria de consumator selectata.",
               parent.parent,
               parent.path,
            );

         if (categorieConsum === "C2" && sumOfIndexLuni > 260344)
            throw new yup.ValidationError(
               "Consumul introdus depaseste pragul maxim acceptat pe categoria de consumator selectata.",
               parent.parent,
               parent.path,
            );

         if (categorieConsum === "C3" && sumOfIndexLuni > 2603440)
            throw new yup.ValidationError(
               "Consumul introdus depaseste pragul maxim acceptat pe categoria de consumator selectata.",
               parent.parent,
               parent.path,
            );

         return true;
      }),
      // indexContorPhoto: yup.mixed(),
      indexContorPhoto: yup.mixed().test("fileFormat", "Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", (value, parent) => {
         //daca nu exista fisierul -> return true
         if (!value) return true;
         //daca este obiect gol si acesta nu este fisier -> return true
         if (checkIfEmptyObject(value)) return true;

         ////daca este obiect gol si acesta nu este fisier -> eroare
         //  if (checkIfEmptyObject(value))
         //    throw new yup.ValidationError("Fișierul trebuie reîncărcat", parent.parent, parent.path);

         //BASE64 FORMAT
         if (typeof value === "string") {
            const fileFormat = value.split(";")[0].split("/")[1];
            const isValidFormat = supportedFormatsBase64.includes(fileFormat);
            //daca fisierul nu are unul din formatele acceptate -> eroare
            if (!isValidFormat)
               throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

            return true;
         }

         //FILE FORMAT
         const fileFormat = value?.type;
         const isValidFormat = supportedFormatsFile.includes(fileFormat);
         //daca fisierul nu are unul din formatele acceptate -> eroare
         if (!isValidFormat)
            throw new yup.ValidationError("Fișierul nu este în formatul corespunzător (pdf, png, jpg, jpeg)", parent.parent, parent.path);

         //daca fisierul are mai mult de x MB -> eroare
         if (value.size > 5000000) throw new yup.ValidationError("Fișierul nu poate avea mai mult de 5MB", parent.parent, parent.path);

         return true;
      }),
      // indexContorManual: yup.string().required("Introducerea indexului este obligatorie"),
      // pod: yup
      //    .string()
      //    .matches(clcPodRegex, "CLC-ul introdus are formatul gresit")
      //    .required("Introducerea CLC-ului este obligatorie")
      //    .matches(clcPodRegexCaractere, "CLC-ul introdus are formatul gresit"),

      indexContorManual: yup.mixed().test("indexContorManual", "Acest camp este obligatoriu", (value, parent) => {
         const isPIF = parent.parent.isPIF;

         //indexul nu apare la PIF
         if (isPIF === true) { return true; }

         if (value === '' || value === undefined || value === null) throw new yup.ValidationError("Acest camp este obligatoriu", parent.parent, parent.path);

         return true;
      }),
      pod: yup.string().test("pod", "Introducerea CLC-ului este obligatorie", async (value, parent) => {
         if (!value) throw new yup.ValidationError("Introducerea CLC-ului este obligatorie", parent.parent, parent.path);

         const isPodValid = clcPodRegex.test(value);
         if (!isPodValid) throw new yup.ValidationError("CLC-ul introdus are formatul gresit", parent.parent, parent.path);

         const response = await requestJson(`${process.env.REACT_APP_API_ENDPOINT_B2C_PAS7_CLC_VERIFY}${value}`, RequestMethod.POST);
         if (response.isSuccess === false || response?.response !== 200){
            throw new yup.ValidationError(
               "Codul locului de consum introdus nu este valid! Te rugăm să verifici corectitudinea acestuia (codul locului de consum se regăsește în factura de gaze naturale)",
               parent.parent,
               parent.path,
            );
         }

         return true;
      }),
   },
   //    indexContorPhoto: yup.mixed().when("indexContorManual", {
   //       is: val => !!val,
   //       then: yup.mixed(),
   //       otherwise: yup.mixed().required("Fisierul este obligatoriu"),
   //    }),
   //    indexContorManual: yup.string().when("indexContorPhoto", {
   //       is: val => !!val,
   //       then: yup.string(),
   //       otherwise: yup.string().required("Introducerea indexului este obligatorie"),
   //    }),
   //    pod: yup.string().required("Acest camp este obligatoriu"),
   //    dataLivrare: yup.string().required("Acest camp este obligatoriu"),
   // },
   // [["indexContorPhoto", "indexContorManual"]],
);
